function generateSlots(anchor: number, step: number, totalCards: number): number[] {
    const slots: number[] = [];
    let position = anchor;

    while (position <= totalCards) {
        slots.push(position);
        position += step;
    }

    return slots;
}

export default generateSlots;
